const contactsData = [
    {
        id: 1,
        street: "Rua Dr. Roberto Frias s/n ",
        postal: "4200-465 Porto",
        building: "Edifício E - Departamento de Engenharia Química da FEUP",
        email: "neeq@fe.up.pt",
        phone: "+351 968 163 624",
        google_maps: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2123.452208658427!2d-8.59693050019786!3d41.17784194278101!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd246440fa1730db%3A0xcfea8b831b53d0b!2sDepartamento+De+Engenharia+Qu%C3%ADmica!5e0!3m2!1spt-PT!2spt!4v1566391550270!5m2!1spt-PT!2spt"
    }
]

export default contactsData;
